(() => {
  const root = document.documentElement;
  const experience = document.querySelector('[data-disco-experience]');
  if (!experience || root.dataset.discoSale !== 'on') return;

  root.dataset.pageType = document.body?.className.match(/template-([\w-]+)/)?.[1] || 'page';

  const dialog = experience.querySelector('[data-disco-dialog]');
  const closeButton = experience.querySelector('[data-disco-close]');
  const progress = experience.querySelector('[data-disco-progress]');
  const floatingTrigger = experience.querySelector('.disco-dj-trigger');
  const cursor = experience.querySelector('[data-disco-cursor]');
  const cursorTrail = experience.querySelector('[data-disco-cursor-trail]');
  const confetti = experience.querySelector('[data-disco-confetti]');
  const scoreNode = experience.querySelector('[data-disco-score]');
  const timerNode = experience.querySelector('[data-disco-timer]');
  const levelNode = experience.querySelector('[data-disco-level]');
  const game = experience.querySelector('[data-disco-game]');
  const statusNode = experience.querySelector('[data-disco-status]');
  const resetButton = experience.querySelector('[data-disco-reset]');
  const musicButton = experience.querySelector('[data-disco-music]');
  const musicLabel = experience.querySelector('[data-disco-music-label]');
  const musicStatus = experience.querySelector('[data-disco-music-status]');
  const musicProgress = experience.querySelector('[data-disco-music-progress]');
  const controlStatus = experience.querySelector('[data-disco-control-status]');
  const audio = experience.querySelector('[data-disco-audio]');
  const tiles = [...experience.querySelectorAll('[data-disco-tile]')];
  const cartDrawer = document.getElementById('site-cart-sidebar');

  const searchTriggers = [...document.querySelectorAll('[id^="search-drawer-trigger"][aria-controls]')];

  searchTriggers.forEach((trigger) => {
    trigger.addEventListener('click', () => {
      window.setTimeout(() => {
        const drawer = document.getElementById(trigger.getAttribute('aria-controls'));
        const isOpen = Boolean(drawer?.classList.contains('active'));
        trigger.setAttribute('aria-expanded', String(isOpen));
        if (isOpen) {
          const headerHeight = document.querySelector('.site-header')?.getBoundingClientRect().height || 78;
          drawer.style.setProperty('--disco-search-top', `${Math.max(8, headerHeight + 8)}px`);
          drawer.querySelector('input[type="search"], input[name="q"]')?.focus({ preventScroll: true });
        }
      }, 60);
    });
  });
  const motionReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const GAME_GOAL = 5;
  const GAME_DURATION = 20;
  const TARGET_VISIBLE_STAGES = motionReduced ? [900, 820, 740, 660, 580] : [720, 650, 580, 510, 440];
  const TARGET_INTERVAL_STAGES = motionReduced ? [1250, 1140, 1030, 920, 810] : [1050, 930, 820, 720, 640];
  let score = 0;
  let target = -1;
  let secondsLeft = GAME_DURATION;
  let gameActive = false;
  let gameCountdownTimer = 0;
  let gameTargetTimer = 0;
  let gameHideTimer = 0;
  let keyBuffer = '';
  let scrollTicking = false;
  let wantsMusic = false;
  let musicRequest = 0;
  let lastMusicSave = 0;
  let controlFeedbackTimer = 0;
  let cartSliderResetTimer = 0;
  let cartSliderLateResetTimer = 0;

  const defaultPalette = {
    navy: root.style.getPropertyValue('--disco-navy').trim() || '#0a1e4a',
    burgundy: root.style.getPropertyValue('--disco-burgundy').trim() || '#6c1835',
    pink: root.style.getPropertyValue('--disco-pink').trim() || '#ec3768',
    orange: root.style.getPropertyValue('--disco-orange').trim() || '#f47b35',
    yellow: root.style.getPropertyValue('--disco-yellow').trim() || '#ffc33c',
    aqua: root.style.getPropertyValue('--disco-aqua').trim() || '#7bdde2',
  };
  const palettes = {
    classic: defaultPalette,
    midnight: { navy: '#080d2b', burgundy: '#32135f', pink: '#c64dff', orange: '#28c6d6', yellow: '#d7ff58', aqua: '#7ce4ff' },
    sorbet: { navy: '#412239', burgundy: '#8c2645', pink: '#ff548c', orange: '#ff8f4d', yellow: '#ffd85c', aqua: '#9be8d8' },
  };

  const safeStorage = {
    get(key) {
      try { return window.sessionStorage.getItem(key); } catch (_) { return null; }
    },
    set(key, value) {
      try { window.sessionStorage.setItem(key, value); } catch (_) { /* Browsing still works without storage. */ }
    },
  };

  const resetCartGiftSlider = () => {
    if (!cartDrawer?.classList.contains('sidebar--opened')) return;
    cartDrawer.querySelectorAll('.cart-gift-product css-slider').forEach((slider) => {
      if (typeof slider.initializeSlider === 'function') slider.initializeSlider();
      if (typeof slider.resetSlider === 'function') slider.resetSlider(true, false);
    });
  };

  const scheduleCartGiftSliderReset = () => {
    window.clearTimeout(cartSliderResetTimer);
    window.requestAnimationFrame(resetCartGiftSlider);
    cartSliderResetTimer = window.setTimeout(resetCartGiftSlider, 240);
  };

  if (cartDrawer) {
    let cartDrawerWasOpen = false;
    const syncCartDrawerState = () => {
      const isOpen = cartDrawer.classList.contains('sidebar--opened');
      root.classList.toggle('disco-cart-open', isOpen);
      if (isOpen === cartDrawerWasOpen) return;
      cartDrawerWasOpen = isOpen;
      window.clearTimeout(cartSliderLateResetTimer);
      if (isOpen) {
        cartDrawer.querySelector('.sidebar__body')?.scrollTo({ top: 0, behavior: 'auto' });
        scheduleCartGiftSliderReset();
        cartSliderLateResetTimer = window.setTimeout(resetCartGiftSlider, 1200);
      }
    };
    new MutationObserver(syncCartDrawerState).observe(cartDrawer, {
      attributes: true,
      attributeFilter: ['class'],
    });
    document.addEventListener('cart-updated', scheduleCartGiftSliderReset);
    document.addEventListener('cart:updated', scheduleCartGiftSliderReset);
    document.addEventListener('cart:refresh', scheduleCartGiftSliderReset);
    new MutationObserver((mutations) => {
      if (mutations.some((mutation) => mutation.target.matches?.('upsell-item'))) {
        scheduleCartGiftSliderReset();
      }
    }).observe(cartDrawer, {
      attributes: true,
      attributeFilter: ['hidden', 'aria-hidden'],
      subtree: true,
    });
    window.addEventListener('resize', () => {
      if (cartDrawer.classList.contains('sidebar--opened')) scheduleCartGiftSliderReset();
    }, { passive: true });
    syncCartDrawerState();
  }

  const setPressed = (selector, value) => {
    experience.querySelectorAll(selector).forEach((button) => {
      button.setAttribute('aria-pressed', String(button.dataset.discoTempo === value || button.dataset.discoPalette === value));
    });
  };

  const announceControl = (message) => {
    if (controlStatus) controlStatus.textContent = message;
    window.clearTimeout(controlFeedbackTimer);
    experience.classList.remove('is-control-change');
    window.requestAnimationFrame(() => experience.classList.add('is-control-change'));
    controlFeedbackTimer = window.setTimeout(() => experience.classList.remove('is-control-change'), 850);
  };

  const setTempo = (value) => {
    const tempo = ['slow', 'normal', 'fast'].includes(value) ? value : 'normal';
    root.dataset.discoTempo = motionReduced ? 'slow' : tempo;
    setPressed('[data-disco-tempo]', tempo);
    safeStorage.set('shop-sante-disco-tempo', tempo);
    const labels = {
      slow: 'Slow activé — les lumières respirent doucement.',
      normal: 'Groove activé — le rythme original est de retour.',
      fast: 'Fever activé — le site passe en vitesse dancefloor.',
    };
    announceControl(labels[tempo]);
  };

  const setPalette = (value) => {
    const palette = ['classic', 'midnight', 'sorbet'].includes(value) ? value : 'classic';
    root.dataset.discoPalette = palette;
    Object.entries(palettes[palette]).forEach(([name, color]) => root.style.setProperty(`--disco-${name}`, color));
    setPressed('[data-disco-palette]', palette);
    safeStorage.set('shop-sante-disco-palette', palette);
    const labels = {
      classic: 'Ambiance Originale — rose, orange et bleu Shop Santé.',
      midnight: 'Ambiance Minuit — néons électriques et piste nocturne.',
      sorbet: 'Ambiance Sorbet — couleurs fruitées et chaleur rétro.',
    };
    announceControl(labels[palette]);
  };

  const setTarget = (visible = false) => {
    tiles.forEach((tile, index) => {
      const isTarget = visible && index === target;
      tile.classList.toggle('is-target', isTarget);
      tile.setAttribute('aria-label', isTarget ? `Tuile ${index + 1}, reflet brillant` : `Tuile ${index + 1}`);
    });
  };

  const clearGameTimers = () => {
    window.clearInterval(gameCountdownTimer);
    window.clearTimeout(gameTargetTimer);
    window.clearTimeout(gameHideTimer);
  };

  const updateGameDisplay = () => {
    if (scoreNode) scoreNode.textContent = `${score} / ${GAME_GOAL}`;
    if (timerNode) timerNode.textContent = `${secondsLeft} s`;
    if (levelNode) levelNode.textContent = `Vitesse ${Math.min(score + 1, GAME_GOAL)} / ${GAME_GOAL}`;
  };

  const stopGame = (message = 'Appuie sur « Lancer le défi » quand tu es prêt.') => {
    clearGameTimers();
    gameActive = false;
    target = -1;
    setTarget(false);
    game?.classList.remove('is-playing');
    if (statusNode) statusNode.textContent = message;
    if (resetButton) resetButton.textContent = 'Lancer le défi';
  };

  const finishGame = (won) => {
    clearGameTimers();
    gameActive = false;
    target = -1;
    setTarget(false);
    game?.classList.remove('is-playing');
    if (resetButton) resetButton.textContent = 'Rejouer';
    if (statusNode) {
      statusNode.textContent = won
        ? `Grand final! ${GAME_GOAL} reflets attrapés avec ${secondsLeft} seconde${secondsLeft > 1 ? 's' : ''} au chrono.`
        : `Temps écoulé — ${score} reflet${score > 1 ? 's' : ''} sur ${GAME_GOAL}. Retente le mix!`;
    }
    if (won) celebrate();
  };

  const showNextTarget = () => {
    if (!gameActive || !tiles.length) return;
    window.clearTimeout(gameTargetTimer);
    window.clearTimeout(gameHideTimer);
    setTarget(false);
    let nextTarget = Math.floor(Math.random() * tiles.length);
    if (tiles.length > 1) {
      while (nextTarget === target) nextTarget = Math.floor(Math.random() * tiles.length);
    }
    target = nextTarget;
    setTarget(true);
    const stage = Math.min(score, GAME_GOAL - 1);
    gameHideTimer = window.setTimeout(() => setTarget(false), TARGET_VISIBLE_STAGES[stage]);
    gameTargetTimer = window.setTimeout(showNextTarget, TARGET_INTERVAL_STAGES[stage]);
  };

  const startGame = () => {
    clearGameTimers();
    score = 0;
    secondsLeft = GAME_DURATION;
    gameActive = true;
    target = -1;
    tiles.forEach((tile) => tile.classList.remove('is-hit', 'is-miss'));
    root.dataset.discoParty = 'off';
    game?.classList.add('is-playing');
    if (resetButton) resetButton.textContent = 'Recommencer';
    if (statusNode) statusNode.textContent = 'Go! Chaque point accélère la piste — garde le rythme jusqu’au niveau 5.';
    updateGameDisplay();
    showNextTarget();
    gameCountdownTimer = window.setInterval(() => {
      secondsLeft = Math.max(0, secondsLeft - 1);
      updateGameDisplay();
      if (secondsLeft === 0) finishGame(false);
    }, 1000);
  };

  // The same preference is used by the password page and the storefront.
  // No audio is downloaded until a shopper has explicitly enabled it.
  const musicKey = 'shop-sante-disco-music';
  const musicPreference = {
    get() {
      try { return window.localStorage.getItem(musicKey) || safeStorage.get(musicKey); }
      catch (_) { return safeStorage.get(musicKey); }
    },
    set(value) {
      safeStorage.set(musicKey, value);
      try { window.localStorage.setItem(musicKey, value); } catch (_) {}
    },
  };
  const english = root.lang.startsWith('en');
  const updateMusic = () => {
    const playing = Boolean(wantsMusic && audio && !audio.paused);
    musicButton?.setAttribute('aria-pressed', String(playing));
    musicButton?.classList.toggle('is-playing', playing);
    experience.classList.toggle('is-music-playing', playing);
    if (musicLabel) musicLabel.textContent = english
      ? (playing ? 'Pause the music' : 'Play the song')
      : (playing ? 'Couper le groove' : 'Écouter la chanson');
  };
  const saveMusicPosition = () => {
    if (audio?.readyState) safeStorage.set('shop-sante-disco-music-time', String(audio.currentTime));
  };
  const setMusic = async (enabled, remember = true) => {
    if (!musicButton || !audio) return;
    const request = ++musicRequest;
    wantsMusic = enabled;
    if (remember) musicPreference.set(enabled ? 'playing' : 'manual-paused');
    if (!enabled) {
      saveMusicPosition();
      audio.pause();
      updateMusic();
      if (musicStatus) musicStatus.textContent = english ? 'Paused — your choice is saved.' : 'En pause — ton choix est mémorisé.';
      return;
    }
    audio.volume = 0.72;
    try {
      await audio.play();
      if (request !== musicRequest) return;
      // A pause can arrive while the browser is still loading the track.
      if (!wantsMusic || musicPreference.get() === 'manual-paused') { audio.pause(); return; }
      if (musicStatus) musicStatus.textContent = english ? 'Official song playing • soft volume' : 'Chanson officielle en cours • volume doux';
    } catch (_) {
      if (request !== musicRequest) return;
      if (wantsMusic && musicStatus) musicStatus.textContent = english ? 'Press Play the song to enable audio.' : 'Appuie sur Écouter la chanson pour activer le son.';
      wantsMusic = false;
    }
    updateMusic();
  };
  audio?.addEventListener('play', () => {
    if (!wantsMusic || musicPreference.get() === 'manual-paused') audio.pause();
    updateMusic();
  });
  audio?.addEventListener('pause', updateMusic);
  audio?.addEventListener('timeupdate', () => {
    const ratio = audio.duration ? audio.currentTime / audio.duration : 0;
    if (dialog?.open && musicProgress) musicProgress.style.transform = `scaleX(${Math.min(1, ratio)})`;
    if (Date.now() - lastMusicSave > 2000) { saveMusicPosition(); lastMusicSave = Date.now(); }
  });
  audio?.addEventListener('loadedmetadata', () => {
    const savedTime = Number(safeStorage.get('shop-sante-disco-music-time'));
    if (Number.isFinite(savedTime) && savedTime > 0 && savedTime < audio.duration - 2) audio.currentTime = savedTime;
  }, { once: true });
  window.addEventListener('storage', (event) => {
    if (event.key === musicKey && event.newValue !== 'playing') setMusic(false, false);
  });
  window.addEventListener('pagehide', () => { setMusic(false, false); stopGame(); });
  window.addEventListener('pageshow', (event) => {
    if (event.persisted && musicPreference.get() === 'playing') setMusic(true, false);
  });

  const openDialog = () => {
    if (!dialog) return;
    if (typeof dialog.showModal === 'function') {
      if (!dialog.open) dialog.showModal();
    } else {
      dialog.setAttribute('open', '');
    }
    root.classList.add('disco-dialog-open');
    closeButton?.focus({ preventScroll: true });
  };

  const closeDialog = () => {
    if (!dialog) return;
    stopGame();
    root.classList.remove('disco-dialog-open');
    if (typeof dialog.close === 'function' && dialog.open) dialog.close();
    else dialog.removeAttribute('open');
  };

  const celebrate = () => {
    root.dataset.discoParty = 'on';
    if (motionReduced || !confetti) return;
    confetti.replaceChildren();
    const fragment = document.createDocumentFragment();
    for (let i = 0; i < 32; i += 1) {
      const piece = document.createElement('i');
      piece.style.left = `${Math.random() * 100}%`;
      piece.style.animationDelay = `${Math.random() * 0.55}s`;
      piece.style.setProperty('--drift', `${-70 + Math.random() * 140}px`);
      piece.style.setProperty('--spin', `${180 + Math.random() * 720}deg`);
      fragment.append(piece);
    }
    confetti.append(fragment);
    window.setTimeout(() => confetti.replaceChildren(), 2600);
  };

  const activateEasterEgg = () => {
    openDialog();
    root.dataset.discoParty = 'on';
    experience.classList.add('is-secret');
    if (controlStatus) controlStatus.textContent = 'MODE SECRET DISCO DÉBLOQUÉ — boule à facettes au maximum!';
    celebrate();
    window.setTimeout(() => experience.classList.remove('is-secret'), 3600);
  };

  const playTile = (button) => {
    if (!gameActive) {
      if (statusNode) statusNode.textContent = 'Lance d’abord le chrono — puis attrape les reflets avant qu’ils disparaissent.';
      return;
    }
    const index = Number(button.dataset.discoTile);
    const hit = index === target && button.classList.contains('is-target');
    if (hit) {
      score += 1;
      button.classList.add('is-hit');
      window.setTimeout(() => button.classList.remove('is-hit'), 220);
      updateGameDisplay();
      if (score >= GAME_GOAL) {
        finishGame(true);
        return;
      }
      if (statusNode) statusNode.textContent = `Touché! Encore ${GAME_GOAL - score} avant le grand final.`;
      showNextTarget();
    } else {
      secondsLeft = Math.max(0, secondsLeft - 1);
      button.classList.add('is-miss');
      window.setTimeout(() => button.classList.remove('is-miss'), 260);
      updateGameDisplay();
      if (statusNode) statusNode.textContent = 'Raté — pénalité de 1 seconde. Garde le rythme!';
      if (secondsLeft === 0) finishGame(false);
    }
  };

  experience.querySelectorAll('[data-disco-open]').forEach((button) => button.addEventListener('click', openDialog));
  document.querySelectorAll('[data-disco-open]').forEach((button) => {
    if (!experience.contains(button)) button.addEventListener('click', openDialog);
  });
  closeButton?.addEventListener('click', closeDialog);
  dialog?.addEventListener('close', () => {
    stopGame();
    root.classList.remove('disco-dialog-open');
  });
  dialog?.addEventListener('click', (event) => {
    const box = dialog.getBoundingClientRect();
    const outside = event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom;
    if (outside) closeDialog();
  });
  tiles.forEach((tile) => tile.addEventListener('click', () => playTile(tile)));
  resetButton?.addEventListener('click', startGame);
  musicButton?.addEventListener('click', () => setMusic(!wantsMusic));

  experience.querySelectorAll('[data-disco-tempo]').forEach((button) => {
    button.addEventListener('click', () => setTempo(button.dataset.discoTempo));
  });
  experience.querySelectorAll('[data-disco-palette]').forEach((button) => {
    button.addEventListener('click', () => setPalette(button.dataset.discoPalette));
  });
  experience.querySelector('[data-disco-secret]')?.addEventListener('click', activateEasterEgg);

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      searchTriggers.forEach((trigger) => {
        const drawer = document.getElementById(trigger.getAttribute('aria-controls'));
        if (!drawer?.classList.contains('active')) return;
        drawer.classList.remove('active');
        trigger.setAttribute('aria-expanded', 'false');
        trigger.focus({ preventScroll: true });
      });
    }
    if (event.metaKey || event.ctrlKey || event.altKey || event.key.length !== 1) return;
    keyBuffer = `${keyBuffer}${event.key.toLowerCase()}`.slice(-5);
    if (keyBuffer === 'disco') {
      keyBuffer = '';
      activateEasterEgg();
    }
  }, true);

  const updateProgress = () => {
    const available = document.documentElement.scrollHeight - window.innerHeight;
    const ratio = available > 0 ? Math.min(1, window.scrollY / available) : 0;
    if (progress) progress.style.transform = `scaleX(${ratio})`;
    if (floatingTrigger) {
      const hasHero = Boolean(document.querySelector('.disco-hero'));
      floatingTrigger.classList.toggle('is-ready', !hasHero || window.scrollY > window.innerHeight * 0.48);
    }
    scrollTicking = false;
  };
  window.addEventListener('scroll', () => {
    if (!scrollTicking) {
      scrollTicking = true;
      window.requestAnimationFrame(updateProgress);
    }
  }, { passive: true });
  updateProgress();

  if (!motionReduced && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-disco-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -4% 0px', threshold: 0 });
    document.querySelectorAll('.main-content > .shopify-section:not(.disco-sale-hero-section), .main-content .container--vertical-space').forEach((section) => {
      section.classList.add('disco-reveal');
      if (section.getBoundingClientRect().top < window.innerHeight * 0.94) {
        section.classList.add('is-disco-visible');
      } else {
        observer.observe(section);
      }
    });
  }

  if (window.matchMedia('(pointer: fine)').matches && !motionReduced) {
    if (cursor && cursorTrail) {
      root.classList.add('disco-cursor-ready');
      let cursorX = 0;
      let cursorY = 0;
      let trailX = 0;
      let trailY = 0;
      let cursorFrame = 0;
      const renderCursor = () => {
        cursorFrame = 0;
        trailX += (cursorX - trailX) * 0.18;
        trailY += (cursorY - trailY) * 0.18;
        cursor.style.transform = `translate3d(${cursorX}px, ${cursorY}px, 0)`;
        cursorTrail.style.transform = `translate3d(${trailX}px, ${trailY}px, 0)`;
        if (Math.abs(cursorX - trailX) + Math.abs(cursorY - trailY) > 0.1) {
          cursorFrame = window.requestAnimationFrame(renderCursor);
        }
      };
      document.addEventListener('pointermove', (event) => {
        cursorX = event.clientX;
        cursorY = event.clientY;
        if (!cursorFrame) cursorFrame = window.requestAnimationFrame(renderCursor);
        cursor.classList.add('is-visible');
        cursorTrail.classList.add('is-visible');
        cursor.classList.toggle('is-interactive', Boolean(event.target.closest('a, button, input, select, textarea, [role="button"]')));
      }, { passive: true });
      const hideCursor = () => {
        window.cancelAnimationFrame(cursorFrame);
        cursorFrame = 0;
        cursor.classList.remove('is-visible');
        cursorTrail.classList.remove('is-visible');
      };
      document.addEventListener('pointerleave', hideCursor);
      document.addEventListener('visibilitychange', () => { if (document.hidden) hideCursor(); });
    }

    document.querySelectorAll('.product-gallery').forEach((gallery) => {
      gallery.addEventListener('pointermove', (event) => {
        const rect = gallery.getBoundingClientRect();
        gallery.style.setProperty('--disco-pointer-x', `${((event.clientX - rect.left) / rect.width) * 100}%`);
        gallery.style.setProperty('--disco-pointer-y', `${((event.clientY - rect.top) / rect.height) * 100}%`);
      }, { passive: true });
    });
  }

  setTempo(safeStorage.get('shop-sante-disco-tempo') || 'normal');
  setPalette(safeStorage.get('shop-sante-disco-palette') || 'classic');
  stopGame();
  updateMusic();
  if (musicPreference.get() === 'playing') setMusic(true, false);
})();
